import { RootState } from '../../../../redux/config';

export const selectAuth = (state: RootState) => state.userData.user;
export const selectToken = (state: RootState) => state.userData.user.token;
export const selectAdminBrands = (state: RootState) =>
  state.userData.user.brands;

// Internal Getaway staff — gates internal-only features (e.g. the Timetable
// view). Matches the exact `@getaway.pro` suffix, case-insensitively.
export const selectIsGetawayAdmin = (state: RootState): boolean =>
  !!state.userData.user.email?.toLowerCase().endsWith('@getaway.pro');

export const selectIsArchivedUsersManager = (state: RootState): boolean =>
  !!state.userData.user?.merchant?.permissions?.archivedUsersManager &&
  !!state.userData.user.permissions?.archivedUsersManager;
